import type { ComponentProps } from 'react'
import Card from '@components/ui/Card/Card'

/** Props passed to `Card` for the profile avatar surface (no `children`). */
export type ProfileAvatarCardProps = Omit<ComponentProps<typeof Card>, 'children' | 'ref'>

/**
 * Per-brand surface options for the profile avatar. Add a row here when a brand
 * should use `Card` instead of the legacy box.
 */
export const PROFILE_AVATAR_CARD_BY_BRAND: Record<'ebac' | 'sir', ProfileAvatarCardProps> = {
  ebac: {
    inversed: true,
    subtone: true,
    elevated: true,
    innerClassName: 'mk-profile__avatar-box-inner',
    className: 'mk-profile__avatar-surface',
  },
  sir: {
    elevated: true,
    subtone: false,
    className: 'mk-profile__avatar-surface mk-profile__avatar-surface--sir',
  },
}

export function getProfileAvatarCardProps(brand: string): ProfileAvatarCardProps | undefined {
  if (brand === 'ebac' || brand === 'sir') {
    return PROFILE_AVATAR_CARD_BY_BRAND[brand]
  }
  return undefined
}
